<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    :width="width"
    top="30px"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-col
        v-for="(item, index) in arrayShow"
        :span="item.span"
        :key="index"
        class="wrap"
      >
        <div :style="{ width: item.labelWidth }" class="title">
          {{ item.title }}
        </div>
        <div v-if="item.type == 'text'" class="text">
          {{ item.value || "-" }}
        </div>
        <div v-if="item.type == 'img'">
          <el-image
            style="width: 160px; height: 90px"
            :src="item.value"
            :preview-src-list="[item.value]"
          >
            <div slot="error" class="image-slot">暂无图片</div>
          </el-image>
        </div>
        <div v-if="item.type == 'files'">
          <div>
            <div v-for="(file, index) in item.files" :key="index">
              <el-button @click="openUrl(file.url)" type="text">{{
                file.name
              }}</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    /**
     * [{title:'',value:'',type:'text',labelWidth:'80px'}]
     * type:text,img,files
     */
    array: {
      type: Array,
      default: function () {
        return [];
      },
    },
    col: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: "信息",
    },
    width: {
      type: String,
      default: "40%",
    },
    labelWidth: {
      type: String,
      default: "100px",
    },
  },
  computed: {
    span() {
      return 24 / this.col;
    },
    arrayShow() {
      let res = [];
      if (this.array) {
        this.array.forEach((r) => {
          r.span = r.span || this.span;
          r.type = r.type || "text";
          r.labelWidth = r.labelWidth || this.labelWidth;
          if (r.type == "img") {
            r.value = r.value
              ? this.$g.host + "/Resources/" + r.value + ".jpg"
              : "";
          }
          if (r.type == "files") {
            let files = [];
            if (r.value) {
              r.value.split(",").forEach((f) => {
                files.push({
                  name: f.split("/")[1],
                  url: this.$g.host + "/Resources/" + f,
                });
              });
            }
            r.files = files;
          }
          res.push({ ...r });
        });
      }
      return res;
    },
  },
  data() {
    return {
      form: {},
      visible: false,
    };
  },
  watch: {
    array() {
      this.visible = true;
    },
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>

</style>
<style lang="scss" scoped>
.wrap {
  display: flex;
  margin: 8px 0;
}



.el-image :deep(.image-slot) {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
}

.el-form-item :deep(.el-form-item__label) {
  font-weight: 600;

}

</style>